import Templates from '../../../base/pages/templates';

const templates: Templates = {
  selectTemplate: 'Select template',
  update: 'Update'
};

export default templates;
